type Listener = () => void;

let activeRequests = 0;
let activeActions = 0;
const requestListeners = new Set<Listener>();
const actionListeners = new Set<Listener>();
const actionMethods = new Set(['post', 'put', 'patch', 'delete']);

const isAction = (method?: string) => actionMethods.has(method?.toLowerCase() || '');
const emit = (listeners: Set<Listener>) => listeners.forEach(listener => listener());

export const start = (method?: string) => {
  const wasBusy = isBusy();
  const wasActionBusy = isActionBusy();
  activeRequests += 1;
  if (isAction(method)) {
    activeActions += 1;
  }
  if (wasBusy !== isBusy()) emit(requestListeners);
  if (wasActionBusy !== isActionBusy()) emit(actionListeners);
};

export const stop = (method?: string) => {
  const wasBusy = isBusy();
  const wasActionBusy = isActionBusy();
  activeRequests = Math.max(0, activeRequests - 1);
  if (isAction(method)) {
    activeActions = Math.max(0, activeActions - 1);
  }
  if (wasBusy !== isBusy()) emit(requestListeners);
  if (wasActionBusy !== isActionBusy()) emit(actionListeners);
};

export const subscribe = (listener: Listener) => {
  requestListeners.add(listener);
  return () => requestListeners.delete(listener);
};

export const subscribeAction = (listener: Listener) => {
  actionListeners.add(listener);
  return () => actionListeners.delete(listener);
};

export const isBusy = () => activeRequests > 0;
export const isActionBusy = () => activeActions > 0;
